import { render, staticRenderFns } from "./VTTextarea.vue?vue&type=template&id=a55b9820&scoped=true&"
import script from "./VTTextarea.vue?vue&type=script&lang=js&"
export * from "./VTTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VTTextarea.vue?vue&type=style&index=0&id=a55b9820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55b9820",
  null
  
)

export default component.exports